import { useCallback } from 'react';
import { store as rtkStore } from 'redux/store';
import { invoiceNotifierApi } from 'redux/services/invoiceNotifierApi';

export const useCreateInvoiceNotifierMutation = () => {
    const { createInvoiceNotifier } = invoiceNotifierApi.endpoints;
    const fetch = useCallback(async (file) => {
        return await rtkStore.dispatch(createInvoiceNotifier.initiate({ file }));

    }, [createInvoiceNotifier]);

    return [
        fetch,
    ];
};
